// extracted by mini-css-extract-plugin
export default {"fuiExpandableTableBtn":"ExpandableTable_fuiExpandableTableBtn__bV5c0"};